"use strict";
/**
 * DFFiles Shared Type Definitions
 * This package contains all shared types, interfaces, and constants
 * used across backend and frontend packages
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Type exports
__exportStar(require("./types/user"), exports);
__exportStar(require("./types/file"), exports);
__exportStar(require("./types/share"), exports);
__exportStar(require("./types/auth"), exports);
__exportStar(require("./types/api"), exports);
__exportStar(require("./types/error"), exports);
__exportStar(require("./types/dynamodb"), exports);
__exportStar(require("./types/contact"), exports);
__exportStar(require("./types/trust"), exports);
__exportStar(require("./types/announcement"), exports);
// Utility exports
__exportStar(require("./utils/validation"), exports);
__exportStar(require("./utils/datetime"), exports);
__exportStar(require("./utils/html"), exports);
__exportStar(require("./utils/file-access"), exports);
__exportStar(require("./utils/csv"), exports);
//# sourceMappingURL=index.js.map